import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {DatevAuthStatusComponent} from '../shared/auth-status/datev-auth-status.component';
import {DatevAuthStatusService} from '../services/datev-auth-status.service';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-nav',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, DatevAuthStatusComponent, FontAwesomeModule],
    template: `
        <nav class="nav-container">
            <div class="nav-content">
                <div class="nav-left">
                    <a routerLink="/" class="nav-brand">CS GmbH</a>
                    <button class="mobile-menu-button"
                            [attr.aria-label]="isMenuOpen ? 'Menü schließen' : 'Menü öffnen'"
                            [attr.aria-expanded]="isMenuOpen"
                            (click)="toggleMenu()">
                        <span class="menu-icon"></span>
                    </button>
                </div>
                <div class="nav-links" [class.active]="isMenuOpen">
                    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
                    <a routerLinkActive="active"
                       [routerLink]=" ['/employees']"
                       (click)="($event)">Mitarbeiter</a>
                    <a [routerLink]="['/sick-leave/overview']" routerLinkActive="active">Krankmeldungen</a>
                </div>
                <div class="nav-right">
                    <datev-app-auth-status></datev-app-auth-status>
                    <a href="/api/logout"
                       class="logout-icon"
                       title="Logout">
                        <fa-icon [icon]="logoutIcon"></fa-icon>
                    </a>
                </div>
            </div>
        </nav>
    `,
    styles: [`
        .nav-container {
            background-color: #f8f9fa;
            padding: 1rem;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .nav-content {
            max-width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
        }

        .nav-left {
            display: flex;
            align-items: center;
            gap: 1rem;
        }

        .nav-brand {
            font-size: 1.5rem;
            font-weight: bold;
            color: #007bff;
            text-decoration: none;
        }

        .mobile-menu-button {
            display: none;
            background: none;
            border: none;
            padding: 0.5rem;
            cursor: pointer;
        }

        .menu-icon {
            display: block;
            width: 24px;
            height: 2px;
            background-color: #333;
            position: relative;
        }

        .menu-icon::before,
        .menu-icon::after {
            content: '';
            position: absolute;
            width: 24px;
            height: 2px;
            background-color: #333;
            transition: transform 0.3s;
        }

        .menu-icon::before {
            top: -6px;
        }

        .menu-icon::after {
            bottom: -6px;
        }

        .nav-links {
            display: flex;
            gap: 1rem;
        }

        .nav-links a {
            color: #333;
            text-decoration: none;
            padding: 0.5rem 1rem;
            border-radius: 4px;
            transition: all 0.2s;
        }

        .nav-links a:hover:not(.disabled) {
            background-color: #e9ecef;
        }

        .nav-links a.active:not(.disabled) {
            background-color: #007bff;
            color: white;
        }

        .nav-links a.disabled {
            color: #6c757d;
            opacity: 0.6;
        }

        .nav-right {
            display: flex;
            align-items: center;
            gap: 1rem;
        }

        .logout-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background-color: #dc3545;
            color: white;
            text-decoration: none;
            border-radius: 50%;
            font-size: 18px;
            transition: background-color 0.2s, transform 0.2s;
        }

        .logout-icon:hover {
            background-color: #c82333;
            transform: scale(1.05);
        }

        @media (max-width: 768px) {
            .nav-content {
                flex-direction: column;
                align-items: stretch;
            }

            .mobile-menu-button {
                display: block;
            }

            .nav-links {
                display: none;
                flex-direction: column;
                width: 100%;
                margin-top: 1rem;
            }

            .nav-links.active {
                display: flex;
            }

            .nav-right {
                margin-top: 1rem;
                justify-content: space-between;
                width: 100%;
            }

            .logout-icon {
                width: 36px;
                height: 36px;
                font-size: 16px;
            }
        }
    `]
})
export class NavComponent implements OnInit {
    isMenuOpen = false;
    logoutIcon = faSignOutAlt;

    constructor(public datevAuthStatusService: DatevAuthStatusService) {
    }

    ngOnInit(): void { }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
}